<template>
  <div class="productList">
    <div class="content">
      <div class="selectCrumb"> 
        <breadcrumb v-bind:path2="this.cat2"></breadcrumb>
        <!--select order-->
        <div class="collection-header">
          <div class="filters-toolbar-wrapper">
            <div class="filters-toolbar__item-child">
              <p>{{ $t('sortBy') }} :</p>
              <el-select v-model="option" placeholder="Please Select sorting method" value="" @change="updateFilter">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!--end select order-->
      </div>

      <!--列表主题-->
      <div v-if="this.isLoadings" class="product-listing-container">
          <div class="loadmore disableBtn">
            <span>{{ $t('loadingProducts')}}</span>
            <i class="loading">
              <div class="loading-bar"></div>
              <div class="loading-bar"></div>
              <div class="loading-bar"></div>
              <div class="loading-bar"></div>
            </i>
          </div>
      </div>

      <div v-if="!this.isLoadings" class="product-listing-container">
        <ul>
          <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
            <productCard
              v-if='$i18n.locale=="en"'
              v-bind:img="item.Thumbnail"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:inCart="inCart"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              v-bind:endTime="item.EndTime"
              v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
            ></productCard>
            <productCard
              v-if='$i18n.locale=="ch"'
              v-bind:img="item.Thumbnail"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:inCart="inCart"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
              v-bind:endTime="item.EndTime"
              v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
              v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
            ></productCard>
          </li>
        </ul>
        <div class="loadmore disableBtn">
          <span>{{ $t('noMoreProducts')}}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
export default {
  name: "category2",
  components: {
    breadcrumb,
    productCard,
  },
  props: {
    cat2: {
      type: String,
    }
  },
  data() {
    return {
      isLoadings: this.isLoading,
      option:"", // drop down
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: {
              slidesPerView: 1,
          },
          //when width >= 480
          480:{
              slidesPerView: 2,
          },
          768: {
              slidesPerView: 4,
          },
          //when width >= 640
          990: {
              slidesPerView: 4,
          },
          1200:{
              slidesPerView: 4,
          },
          1280: {
              slidesPerView: 5,
          }
        }
      },
      list: []
    }
  },
  methods: {
    ...mapActions('products',['fetchProductsWithCategory2Id', 'fetchWholesaleWithId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
    },
    fetchSelectedCategory2(id) {
      this.isLoadings = true;
      this.fetchProductsWithCategory2Id(id)
      .then(res => {
        this.isLoadings = false;
        let ctemp1 = [];
        let ctemp2 = [];
        let catOut = [];
        let catReg = [];
        res.data.map((a)=>{
          if (this.isOutOfStock(a)) {
            ctemp2.push(a)
          } else {
            ctemp1.push(a)
          }
        })
        catOut = ctemp2.sort((a,b)=>{
           return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.list = catReg.concat(catOut);
      })
      .catch(err => {
        this.isLoadings = true;
        console.log('err', err)
      })
    },
    fetchWholesale(id) {
      this.isLoadings = true;
      this.fetchWholesaleWithId()
      .then(res => {
        this.isLoadings = false;
        const temp1 = [];
        const sortedData = res.data.record.map((a)=>{
          // temp1.push({ IsOverSaleable: false, IsPromotion: true, });
          temp1.push({...a, EndTime: null, group: true, Name: a.ProductName, IsPromotion: true, Product_id: a.Product, Price: a.ProductGroupPrice, OriginalPrice: a.RefPrice});
        })
        console.log('temp1:', temp1);
        // this.list = temp1;
        // this.filterList = this.list;

        // const temp1 = [];
        // const temp2 = [];
        // const sortedData = res.data.map((a)=>{
        //   if(this.isOutOfStock(a)) {
        //     temp2.push(a)
        //   }else {
        //     temp1.push(a)
        //   }
        // }) 
        // this.listOut = temp2.sort((a,b)=>{
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // });
        // this.listReg = temp1.sort((a,b) => {
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // })
        // this.list = this.listReg.concat(this.listOut);
        
        // if(this.$route.params.group == 'group'){
        //   this.list.forEach(item=>{
        //     item.group = true
        //   })
        // }
       
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('cart/getCart');
    next();
  },
  computed: mapState({
    allCategory2: state => state.products.customCategories,
    activeCategory2: state => state.products.activeCategory2,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0]
  }),
  watch: {
    // when hard refresh
    allCategory2: function(newVal, oldVal) {
      const currentCategory2 = newVal.filter(cat2 => {
        return cat2.Name.toLowerCase() === this.cat2.toLowerCase();
      });
      this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id);
    },
    // when select a category2
    cat2: function(newVal, oldVal) {
      const currentCategory2 = this.allCategory2.filter(cat2 => {
        return newVal === cat2.Name.toLowerCase();
      });
      this.option = '';
      this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id);
    },
    $route(to, from) {
      console.log('$route: ', to);
      
      if (to.path === "/category2/Wholesale") {
        this.fetchWholesale(1)
        return;
      }
      // else if (to.name === "productList") {
      //   this.allGroups.forEach(group => {
      //     if (this.group === group.Name.toLowerCase()){
      //       currentGroup.push(group);
      //       currentGroupType = 'group';
      //     }
      //     group.Categories.forEach(item=>{
      //       if(this.group === item.Name.toLowerCase()){
      //         currentGroup.push(item);
      //         currentGroupType = 'category';
      //       }
      //     })
      //   })
      // 
      //   if (currentGroup.length>0 && currentGroupType === 'category') {
      //     this.chgroup = currentGroup[0].Description;
      //     this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category')
      //   }
      //   if (currentGroup.length>0 && currentGroupType === 'group') {
      //     this.chgroup = currentGroup[0].Description;
      //     this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group')
      //   }
      // }
    }
  },
  allGroups: function(newVal, oldVal) {
    console.log('allGroups: ', newVal);
    if(this.$route.params.group == 'Wholesale') {
      this.fetchWholesale(1)
      return
    }
  },
  mounted: function() {
    this.$store.dispatch('products/fetchCustomCategories');
    this.$root.fetchSelectedCategory2 = this.fetchSelectedCategory2.bind(this);
    const currentCategory2 = this.allCategory2.filter(cat2 => {
      return this.cat2 === cat2.Name.toLowerCase();
    });
    this.fetchSelectedCategory2(currentGroup[0].ProductCategory2_id)
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/category2List.less";
</style>



// WEBPACK FOOTER //
// src/view/category2List.vue